
/**
 * Constants.  Cannot put in auth service or account service because
 * that will make a circular dependency.  Put them somewhere...  here I guess.
 */

export const BADGECOUNTS = 'badgeCounts';
export const CACHEKEY_USER = 'user';
export const CACHEKEY_ACCOUNT = 'account';



/**
 * Enum of maximum lengths for standard fields.
 */
 export class MaxLen {
  static Address = 45;
  static City = 45;
  static Company = 80;
  static CompanyUrl = 256;
  static Email = 80;
  static FirstName = 32;
  static LastName = 32;
  static MiddleName = 32;
  static Password = 128;
  static PhoneNumber = 16;
  static PhoneExtension = 6;
  static ShortCode = 6;
  static Zip = 10;
  static ApplicationProvider = 45;
  static PurchaseOrderNumber = 30;

  // let's keep field lengths in a constants
  // file like this and we can share them
  // across all the pages that need them.
  static AccountOwnerName = 80;
  static RoutingNumber = 9;
  static AccountNumber = 17;
  static Brand = 80;
  static legalEntityType = 45;
  static TrackingNumber = 32;
  static UserName = 80;
 }
 
/**
 * Enum of minimum lengths for standard fields.
 */
 export class MinLen {
  static PhoneNumber = 7;
  static ShortCode = 5;
 }
 